export default "__VITE_ASSET__qlhLh6PB__"